"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Представляет собой настраиваемый элемент ввода с расширенными возможностями, такими как проверка ввода, отображение
 * ошибок и динамические изменения состояния в зависимости от взаимодействия пользователя.
 */
class InputPrimary extends HTMLElement {
    constructor() {
        super();
        this.$input = null;
        /** Обработчик события input у поля ввода. */
        this.handleInput = () => {
            this.checkInput();
            this.hideError();
        };
        /** Обработчик события change у поля ввода. */
        this.handleChange = () => {
            this.checkInput();
        };
        /**
         * Показывает ошибку c текстом.
         *
         * @param {String} text
         */
        this.showError = (text) => {
            if (!this.error.inited) {
                this.initErrorElements();
            }
            this.showErrorIcon();
            this.showErrorBadge();
            this.error.$badge.querySelector('span').textContent = text;
            if (this.error.inited) {
                setTimeout(() => {
                    this.hideErrorBadge();
                }, this.FIRST_SHOW_ERROR_DISPLAY_TIMEOUT);
            }
            this.setAttribute('error-state', '');
            this.currentState = 'error';
        };
        /** Скрывает ошибку. */
        this.hideError = () => {
            if (this.currentState !== 'error')
                return;
            this.hideErrorIcon();
            this.hideErrorBadge();
            this.removeAttribute('error-state');
            this.currentState = 'default';
        };
        /**
         * Проверяет поле ввода.
         *
         * @private
         */
        this.checkInput = () => {
            if (this.$input.value.trim().length > 0) {
                this.setAttribute('not-empty', '');
            }
            else {
                this.removeAttribute('not-empty');
            }
        };
        /**
         * Инициализирует и добавляет элементы ошибок.
         *
         * @private
         */
        this.initErrorElements = () => {
            if (!this.error.inited) {
                // Создание иконки ошибки из шаблона
                const iconTemplate = document.createElement('template');
                iconTemplate.innerHTML = `
        <div class='input-primary__icon-wrapper'>
          <div class='input-primary__icon'></div>
        </div>`;
                this.error.$icon = iconTemplate.content.firstElementChild.cloneNode(true);
                // Создание бэйджа ошибки из шаблона
                const badgeTemplate = document.createElement('template');
                badgeTemplate.innerHTML = `
        <div class='input-primary__badge'>
          <span></span>
        </div>`;
                this.error.$badge = badgeTemplate.content.firstElementChild.cloneNode(true);
                /**
                 * Состояния наведения мыши.
                 *
                 * @type {Boolean}
                 */
                let nowMouseEnter = false;
                this.setAttribute('data-error-first-show', '');
                setTimeout(() => {
                    this.error.firstShowDone = true;
                    this.removeAttribute('data-error-first-show');
                    if (nowMouseEnter !== true)
                        this.hideErrorBadge();
                }, this.FIRST_SHOW_ERROR_DISPLAY_TIMEOUT);
                this.error.$icon.addEventListener('mouseenter', () => {
                    nowMouseEnter = true;
                    this.showErrorBadge();
                });
                this.error.$icon.addEventListener('mouseleave', () => {
                    nowMouseEnter = false;
                    this.hideErrorBadge();
                });
                this.insertAdjacentElement('beforeend', this.error.$icon);
                this.insertAdjacentElement('beforeend', this.error.$badge);
                this.error.inited = true;
            }
        };
        /**
         * Показывает иконку для взаимодействия с бэйджиком.
         *
         * @private
         */
        this.showErrorIcon = () => {
            this.error.$icon.setAttribute('data-showed', '');
        };
        /**
         * Скрывает иконку для взаимодействия с бэйджиком.
         *
         * @private
         */
        this.hideErrorIcon = () => {
            this.error.$icon.removeAttribute('data-showed');
        };
        /**
         * Показывает бэйдж с ошибкой.
         *
         * @private
         */
        this.showErrorBadge = () => {
            this.error.$badge.setAttribute('data-showed', '');
        };
        /**
         * Скрывает бэйдж с ошибкой.
         *
         * @private
         */
        this.hideErrorBadge = () => {
            this.error.$badge.removeAttribute('data-showed');
        };
        /**
         * Наименование текущего состояние.
         *
         * @type {String}
         */
        this.currentState = 'default';
        /**
         * Объект для работы с ошибкой.
         *
         * @private
         *
         * @type {Object}
         */
        this.error = {
            has: false,
            inited: false,
            firstShowDone: false,
            $badge: null,
            $icon: null,
        };
        /**
         * Константа задержки отображения ошибки.
         *
         * @type {Number}
         */
        this.FIRST_SHOW_ERROR_DISPLAY_TIMEOUT = 2000;
    }
    connectedCallback() {
        var _a, _b;
        /**
         * Поле ввода.
         *
         * @type {HTMLInputElement | HTMLTextAreaElement}
         */
        this.$input = this.querySelector('.input-primary__text');
        this.checkInput();
        (_a = this.$input) === null || _a === void 0 ? void 0 : _a.addEventListener('input', this.handleInput);
        (_b = this.$input) === null || _b === void 0 ? void 0 : _b.addEventListener('change', this.handleChange);
    }
    disconnectedCallback() {
        var _a, _b;
        (_a = this.$input) === null || _a === void 0 ? void 0 : _a.removeEventListener('input', this.handleInput);
        (_b = this.$input) === null || _b === void 0 ? void 0 : _b.removeEventListener('change', this.handleChange);
    }
}
exports.default = InputPrimary;
